<template lang="html">
  <div id="article-page">

    <div class="container content-section">
      <!-- <div class="row">
        <div class="col-12 mb-3 col-s-title">
          <h2 class="title-g1"><span>Proyectos</span></h2>
        </div>
      </div> -->

      <div class="row">
        <!-- Artículo actual -->
        <div class="col-lg-8 col-article">
          <div class="mb-3 box-image">
            <img :src="row.imageUrl">
          </div>
          <h1 class="title">{{ row.title }}</h1>
          <div class="descr" v-html="row.body"></div>
        </div>
        <!--  -->

        <!-- Artículos -->
        <div class="col-lg-4 col-blog">
          <div class="row">
            <div class="col-12 col-article-sample-1 sample-2" v-for="(project, arInx) in projects" :key="'ar-'+arInx">
              <router-link class="box-article" :to="'/comunicados/'+project.id">
                <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+project.imageUrl+')' }">
                  <img src="public/images/shared/empty.png">
                </div>

                <div class="box-descr">
                  <h5>{{ project.title }}</h5>

                  <div class="descr" v-html="project.body"></div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      row: {
        
      },
      projects: [
      ],
      id: null,
    }
  },

    watch: {
      "$route.params.id" : function(v){
        this.id = this.$root._getURLID(this.$route.params.id);
        this.getRows();
      },
    },

  methods: {
    getRows: function(){
      axios.get(tools.url('/api/projects/'+this.id)).then((response)=>{
          this.row = response.data.row;
          this.projects = response.data.related;
      });
    }
  },

  mounted(){
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getRows();
  }
}
</script>
